import React, { useState } from 'react';
import Papa from 'papaparse';
import { UploadFile } from '../LinkOrUpload';

const CsvReader = ({users, handleSelectedList, getOnlyUserId = false}) => {
  // const [ids, setIds] = useState([]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    
    Papa.parse(file, {
      complete: (result) => {
        const ids = result.data.slice(0).map(row => row["ID"]);
        const data = users.filter(item => ids.includes(item.id));

        if(getOnlyUserId) handleSelectedList(data.map(row => row.id));
        else handleSelectedList(data);
      },
      header: true,
    });
  };

  return (
    <UploadFile labelButton="Arquivo com IDS" handleFileChange={handleFileChange}/>
  );
};

export default CsvReader;